import { render, staticRenderFns } from "./MessageIssuedModal.vue?vue&type=template&id=b3282794&scoped=true&"
import script from "./MessageIssuedModal.vue?vue&type=script&lang=js&"
export * from "./MessageIssuedModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageIssuedModal.vue?vue&type=style&index=0&id=b3282794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3282794",
  null
  
)

export default component.exports